import { render, staticRenderFns } from "./GCustomBreadCrumb.vue?vue&type=template&id=a9aec9c6&scoped=true&"
import script from "./GCustomBreadCrumb.vue?vue&type=script&lang=ts&"
export * from "./GCustomBreadCrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aec9c6",
  null
  
)

export default component.exports